import { render, staticRenderFns } from "./ConfirmChange.vue?vue&type=template&id=354f1aae&scoped=true"
import script from "./ConfirmChange.vue?vue&type=script&lang=js"
export * from "./ConfirmChange.vue?vue&type=script&lang=js"
import style0 from "./ConfirmChange.vue?vue&type=style&index=0&id=354f1aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f1aae",
  null
  
)

export default component.exports